import { Component } from 'react';

import AlreadyHasActiveAccount from 'pages/already_has_active_account';
import DeclinePage from 'pages/decline';
import P2PSuccessPage from 'pages/p2p_success';
import PendingPage from 'pages/pending';
import SuccessPage from 'pages/success';
import SuccessCBRNoRewardsPage from 'pages/success_cb_no_rewards';
import SuccessCBRewardsPage from 'pages/success_cb_rewards';
import SuccessCBRewardsPendingPage from 'pages/success_cb_rewards_pending';
import VerifyScanIdPage from 'pages/verify_scan_id';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { loaderHidden } from 'actions/loaderHidden';
import { modalHidden } from 'actions/modalHidden';

import PageLoader from 'components/Loaders/PageLoader';
import Modal from 'components/Modal';

import { IS_PAY_ANYONE_P2P } from 'consts/appConsts';
import {
  ALREADY_HAS_ACTIVE_ACCOUNT_ROUTE,
  cbRewardsRoutes,
  DECLINE_ROUTE,
  PENDING_ROUTE,
  SUCCESS_ROUTE,
  VERIFY_SCAN_ID_ROUTE,
} from 'consts/routeConsts';

import { selectModalContent, selectModalDisplay } from 'selectors/modal';

export class RenderPostEnrollmentRoutes extends Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    modalDisplay: PropTypes.bool,
    modalContent: PropTypes.string,
    dispatch: PropTypes.func,
  };

  componentDidMount() {
    this.props.dispatch(loaderHidden());
  }

  componentDidUpdate(prevProps) {
    const { location, modalDisplay, dispatch } = this.props;

    const currentLocation = location.pathname;
    const prevLocation = prevProps.location.pathname;

    // This clears out any hanging modal on navigation
    if (currentLocation !== prevLocation && modalDisplay) {
      dispatch(modalHidden());
    }
  }

  render() {
    const { history, modalDisplay, modalContent, dispatch } = this.props;

    return (
      <>
        <Switch>
          <Route path={ALREADY_HAS_ACTIVE_ACCOUNT_ROUTE.path}>
            <AlreadyHasActiveAccount />
          </Route>
          <Route path={VERIFY_SCAN_ID_ROUTE.path}>
            <VerifyScanIdPage history={history} />
          </Route>
          <Route path={cbRewardsRoutes.CB_REWARDS_SUCCESS}>
            <SuccessCBRewardsPage />
          </Route>
          <Route path={cbRewardsRoutes.CB_SUCCESS_NO_REWARDS}>
            <SuccessCBRNoRewardsPage />
          </Route>
          <Route path={cbRewardsRoutes.CB_PENDING_REWARDS_SUCCESS}>
            <SuccessCBRewardsPendingPage />
          </Route>
          <Route path={SUCCESS_ROUTE.path}>
            {IS_PAY_ANYONE_P2P ? (
              <P2PSuccessPage history={history} />
            ) : (
              <SuccessPage />
            )}
          </Route>
          <Route path={PENDING_ROUTE.path}>
            <PendingPage />
          </Route>
          <Route path={DECLINE_ROUTE.path}>
            <DeclinePage />
          </Route>
        </Switch>
        <Modal
          handleHide={() => dispatch(modalHidden())}
          display={modalDisplay}
        >
          {modalContent}
        </Modal>
        <PageLoader />
      </>
    );
  }
}

const mapStateToProps = state => ({
  modalDisplay: selectModalDisplay(state),
  modalContent: selectModalContent(state),
});

const ConnectedRenderPostEnrollmentRoutes = connect(mapStateToProps)(
  RenderPostEnrollmentRoutes
);

export default withRouter(ConnectedRenderPostEnrollmentRoutes);
